import React, { useState } from 'react';
import { MedicalServices, Assessment, Celebration, Close } from '@mui/icons-material';
import { useAuth } from '../../core/context/AuthContext';
import DashboardTecnico from '../../features/facturacion/components/DashboardTecnico';
import './Welcome.css';

const MIGRATION_BANNER_KEY = 'sugi_migration_banner_dismissed';

const MigrationBanner = () => {
  const [visible, setVisible] = useState(() => !localStorage.getItem(MIGRATION_BANNER_KEY));

  const dismiss = () => {
    localStorage.setItem(MIGRATION_BANNER_KEY, '1');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="migration-banner">
      <div className="migration-banner-inner">
        <Celebration className="migration-icon" />
        <div className="migration-text">
          <strong>¡SUGI fue migrado en su totalidad!</strong>
          <span>Bienvenido al nuevo y renovado Sistema Único de Gestión Integral. Más rápido, moderno y pensado para vos.</span>
        </div>
        <button className="migration-close" onClick={dismiss} aria-label="Cerrar">
          <Close fontSize="small" />
        </button>
      </div>
    </div>
  );
};

const Welcome = () => {
  const { user } = useAuth();
  const isTecnico = user?.role === 'Tecnico';

  return (
    <>
      <MigrationBanner />
      <div className="welcome-wrapper">

        {/* Hero */}
        <div className="welcome-hero">
          <div className="welcome-hero-shapes">
            <div className="wh-shape wh-shape-1" />
            <div className="wh-shape wh-shape-2" />
            <div className="wh-shape wh-shape-3" />
          </div>
          <div className="welcome-hero-inner">
            <div className="welcome-logos">
              <img src="https://sugi.com.ar/Img/logoNS_nuevo.png" alt="NeuroSueño Logo" className="welcome-logo-primary" />
              <div className="welcome-logo-divider" />
              <img src="https://sugi.com.ar/Img/LogoLoginFondo.png" alt="SUGI Logo" className="welcome-logo-secondary" />
            </div>
            <h1 className="welcome-hero-title">
              Bienvenido a NeuroSueño.com
            </h1>
            <p className="welcome-hero-subtitle">Sistema Único de Gestión Integral</p>
          </div>
        </div>

        {/* Contenido */}
        <div className="welcome-content-area">
          <div className={`welcome-grid ${isTecnico ? 'welcome-grid-tecnico' : ''}`}>

            <div className="welcome-main">

              {/* Sobre NeuroSueño */}
              <div className="welcome-section-card">
                <p className="welcome-body-text">
                  Neurosueño.com es un Centro dedicado al diagnóstico, prevención, y tratamiento de los trastornos del sueño,
                  específicamente a la patología respiratoria del sueño.
                </p>
                <p className="welcome-body-text">
                  Neurosueño.com nace en la Ciudad de Lobos como respuesta a la necesidad de contar en la provincia de Buenos Aires
                  con un Centro especializado en la detección, seguimiento y tratamiento de este tipo de enfermedades.
                  Desde 2010 somos en esta zona el único Centro privado dedicado a estos estudios.
                </p>
              </div>

              {/* Dos cards inferiores */}
              <div className="welcome-cards-row">
                <div className="welcome-info-card">
                  <div className="welcome-info-card-icon">
                    <Assessment sx={{ fontSize: 28, color: '#6d1212' }} />
                  </div>
                  <div>
                    <p className="welcome-body-text" style={{ margin: 0 }}>
                      <strong>SUGI (Sistema Único de Gestión Integral)</strong> es nuestra plataforma tecnológica diseñada para optimizar
                      la gestión completa de estudios del sueño. Permite la administración eficiente de turnos, seguimiento de pacientes,
                      gestión de prácticas médicas, control de informes técnicos y liquidaciones, garantizando un flujo de trabajo ágil
                      y trazabilidad completa en cada etapa del proceso diagnóstico y terapéutico.
                    </p>
                  </div>
                </div>

                <div className="welcome-info-card">
                  <div className="welcome-info-card-icon">
                    <MedicalServices sx={{ fontSize: 28, color: '#6d1212' }} />
                  </div>
                  <div>
                    <p className="welcome-body-text" style={{ margin: 0 }}>
                      Contamos con tecnología de última generación para la realización de Polisomnografías (PSG) y Poligrafías Respiratorias (PR),
                      equipos CPAP para tratamiento de apnea del sueño, y un equipo de profesionales especializados en medicina del sueño
                      comprometidos con la excelencia en el cuidado de nuestros pacientes.
                    </p>
                  </div>
                </div>
              </div>

            </div>

            {isTecnico && (
              <div className="welcome-dashboard">
                <DashboardTecnico />
              </div>
            )}

          </div>
        </div>

      </div>
    </>
  );
};

export default Welcome;
